import { useMemo } from 'react';
import type { FC } from 'react';

import type { CarouselProps } from '@xing-com/carousel';
import { Carousel } from '@xing-com/carousel';
import { Ad, SiteSections } from '@xing-com/crate-ads-native-ads';
import type { AdFields } from '@xing-com/crate-ads-native-ads';
import type { SimilarJobData } from '@xing-com/crate-jobs-helpers';
import { spaceL, spaceS } from '@xing-com/tokens';

import { SimilarJob } from '../similar-job';

export const getCarouselConfig = (
  itemWidthMobile = '80%',
  itemWidthConfined = '45%',
  itemSpacing = spaceS
): Partial<CarouselProps> => ({
  // mobile
  itemWidth: itemWidthMobile,
  itemSpacing: itemSpacing,

  // tablet
  itemWidthConfined: itemWidthConfined,
  itemSpacingConfined: itemSpacing,

  // desktop only for the initial load of the page
  itemWidthWide: `calc((100% - ${spaceL} * 2) / 3)`,
  itemSpacingWide: spaceL,
});

type Props = { similarJobs: SimilarJobData[]; ads?: AdFields[] };

export const SimilarJobsCarousel: FC<Props> = ({ similarJobs, ads = [] }) => {
  const items = useMemo(() => {
    const similarJobComponents = similarJobs.map((similarJob) => (
      <SimilarJob
        ijtParam="jb_20"
        isCarousel
        key={similarJob.job.id}
        similarJob={similarJob}
      />
    ));
    const adComponent =
      ads?.length > 0 ? (
        <Ad sectionId={SiteSections.JobsDetails} {...ads?.[0]} />
      ) : null;
    return [...similarJobComponents, adComponent].filter((item) => !!item);
  }, [similarJobs, ads]);

  return (
    <Carousel {...getCarouselConfig()} tabIndex={-1}>
      {items}
    </Carousel>
  );
};
